import { render, staticRenderFns } from "./ShipStatusRow.vue?vue&type=template&id=e15fceee&scoped=true&"
import script from "./ShipStatusRow.vue?vue&type=script&lang=js&"
export * from "./ShipStatusRow.vue?vue&type=script&lang=js&"
import style0 from "./ShipStatusRow.vue?vue&type=style&index=0&id=e15fceee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15fceee",
  null
  
)

export default component.exports